import { Modal } from "antd";
import { Formik, Form } from "formik";
import React, { cloneElement } from "react";

const AddElementLayout = (props) => {
    const {
        isModalOpen,
        handleCancel,
        initialValue,
        validationSchema,
        handleSubmitForm,
        title,
        children,
        width = 520
    } = props

    return (
        <Modal
            footer={null}
            title={title}
            open={isModalOpen}
            onCancel={handleCancel}
            width={width}
        >
            <Formik
                initialValues={initialValue}
                validationSchema={validationSchema}
                onSubmit={(values, submitProps) => {
                    handleSubmitForm(values, submitProps)
                }}
            >
                {({ values }) => (
                    <Form>
                        {children}
                    </Form>
                )}
            </Formik>
        </Modal>
    );
}

export default AddElementLayout;